// extracted by mini-css-extract-plugin
export default {"secondaryTag":"FfH6KP7R0Vi5Ps7ZXB43","bulletsContainer":"iuffMajb4PhB_uMSdIB_"};